import React from 'react';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

export const AdsTxtLinesList = ({lines}) => {
  const filteredLines = lines?.filter(line => line !== '') ?? [];

  return (
    <Grid container style={{fontFamily: 'monospace'}} spacing={1} justify="flex-end">
      <Grid item xs={1}>
        <Paper elevation={0}>
          {filteredLines.map((line, i) => (
            <Grid
              key={i}
              item
              xs={12}
              style={{textAlign: 'right', marginRight: 5, marginTop: 2}}
            >
              <Typography variant="caption">{i + 1}</Typography>
            </Grid>
          ))}
        </Paper>
      </Grid>
      <Grid item xs={11}>
        {filteredLines.map((line, i) => (
          <Grid
            key={i}
            item
            xs={12}
            style={{
              marginLeft: 5,
              marginTop: 2,
              background: i % 2 === 0 ? 'rgb(255 255 255 / 5%)' : null,
            }}
          >
            <Typography noWrap variant="caption">
              {line}
            </Typography>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};
